import React, { useState } from "react";
import axios from "axios";
import { useOrderContext } from "../../contexts";
import {
  ContactInfoModal,
  ReviewExchangeSummary,
  ContactInfoCard,
  RazorPay,
  CashFree
} from "../";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import {
  updateExchangeSettingsDetails,
  updateRefundSettingsDetails,
  setProductDetails,
  updateOtherSettings,
  updatePaymentSettings,
} from "../../redux/slices";
import {
  exchangeSettingsActionTypes,
  refundSettingsActionTypes,
  productActionTypes,
  otherSettingsActionTypes,
  paymentSettingTypes,
} from "../../redux/utils";
import { getUpdatedOrderInfo } from "../../Utilities";
import { useHardCode, useAPI } from "../../hooks";
import "./return_review.css";
export const ReturnReview = () => {
  const [isModalOpen, setModalIsOpen] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const { setRecentOrderID, setVariantID } = useOrderContext();
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isStoreArrak = SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.arrak;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  const paymentSettingState = useSelector((state) => state.paymentSettings);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const { SUBMIT_RETURN_REQUEST_API, RETURN_SUBMIT_API } = useAPI();
  const isStorePureFemale =
    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const REVIEW_RETURN = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.review_return
    : storeConfigState?.themeConfig?.return_review_page_left_title;
  const FINAL_API_CALL =
    storeConfigState.platform === "shopify"
      ? SUBMIT_RETURN_REQUEST_API
      : RETURN_SUBMIT_API;
  const backHandler = () => {
    window.history.back();
  };

  const toggleModal = () => {
    setModalIsOpen(!isModalOpen);
  };

  const buttonHandler = () => {
    (async () => {
      setIsLoader(true);
      setIsBtnDisabled(true);

      const RecentOrderID = productDetailsState.recentOrderID;
      const VariantID = selectedProductDetailsState.variantID;
      setRecentOrderID(RecentOrderID);
      setVariantID(VariantID);
      if (
        refundSettingsState.refundReviewRoute === "STORE_CREDIT" ||
        refundSettingsState.refundReviewRoute === "ORIGINAL_PAYMENT"
      ) {
        try {
          const VariantID = selectedProductDetailsState.variantID;
          const productID = selectedProductDetailsState.productID;
          const StoreUniqueID = storeConfigState.storeUniqueID;
          const OrderInfo = productDetailsState.orderInfo;
          const customerID = OrderInfo.customer_id;
          const response = await axios.post(FINAL_API_CALL, {
            test_mode: productDetailsState.testMode,
            store_name: StoreUniqueID,
            email: productDetailsState.customerEmail,
            order_number: productDetailsState.orderNumber,
            order_id: productDetailsState.recentOrderID,
            customer_id: customerID,
            variant_id: VariantID,
            product_id: productID,
            refund_to: refundSettingsState.refundOption,
            is_refund: true,
            image_list: exchangeSettingsState.imageList,
            reason_id: productDetailsState.returnReasonID,
            other_reason_desc: productDetailsState.reasonDetails,
            sub_reason_detail: productDetailsState.subReasonDetails,
            line_item_id: selectedProductDetailsState.lineItemID,
            quantity: parseInt(selectedProductDetailsState.selectedQuantity),
            access_code: otherSettingsState.accessCode,
            incentive: refundSettingsState.incentive,
            customer_data: productDetailsState.customerInfo,
            razorpay_payment_id: refundSettingsState.razorPayPaymentID,
            currency: productDetailsState.sessionCurrency,
            customer_upi_id: paymentSettingState.customerUpiId,
            account_number: paymentSettingState.accountNumber,
            ifsc: paymentSettingState.ifsc,
            beneficiary_name: paymentSettingState.beneficiaryName,
          });

          if (response?.status === 200) {
            if(response.data?.payment_required){
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_COLLECT_PAYMENT_THROUGH,
                  value: response.data?.collect_payment_through,
                })
              );

              dispatch(
                updateOtherSettings({
                  key: otherSettingsActionTypes.UPDATE_RAN,
                  value: response.data.ran,
                })
              );

              dispatch(
                updatePaymentSettings({
                  key: paymentSettingTypes.UPDATE_PAYMENT_ID,
                  value: response.data.id,
                })
              );

              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_AMOUNT,
                  value: response?.data?.payment_amount,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_GATEWAY_INFO,
                  value: response?.data?.razorpay_object?.payment_gateway_info,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_REQUIRED,
                  value: response?.data?.payment_required || false,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_RAZORPAY_PAYMENT_ID,
                  value: "",
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_COLLECT_PAYMENT_THROUGH,
                  value: response.data?.collect_payment_through,
                })
              );

              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_RAZORPAY_DETAILS,
                  value: response?.data?.razorpay_object,
                })
              );

              
    
              setIsLoader(false);
              setIsBtnDisabled(false);
              navigate("/ReturnReview");
          }
          else{
            setIsLoader(false);
            navigate("/ThankYou");
            const isShowRAN =
              SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.steve_maiden
                ? ""
                : `RAN# ${response.data.ran}`;
            const FINAL_THANKYOU_DESC = isStoreArrak
              ? `${storeConfigState?.themeConfig?.we_have_received_your_return_request} ${isShowRAN}. ${storeConfigState?.themeConfig?.request_submitted_label_message}`
              : `${storeConfigState?.themeConfig?.your_return_request} ${isShowRAN} ${storeConfigState?.themeConfig?.has_been_submitted_original_payment_method}`;
            if (refundSettingsState.refundReviewRoute === "ORIGINAL_PAYMENT") {
              dispatch(
                updateOtherSettings({
                  key: otherSettingsActionTypes.UPDATE_RAN,
                  value: response.data.ran,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
                  value: storeConfigState?.themeConfig
                    ?.return_submission_original_payment_left_content
                    ? storeConfigState?.themeConfig
                        ?.return_submission_original_payment_left_content
                    : FINAL_THANKYOU_DESC,
                })
              );
            } else if (
              refundSettingsState.refundReviewRoute === "STORE_CREDIT"
            ) {
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_THANKYOU_HEADING,
                  value:
                    storeConfigState?.themeConfig
                      ?.return_submission_store_credit_left_title,
                })
              );

              dispatch(
                updateOtherSettings({
                  key: otherSettingsActionTypes.UPDATE_RAN,
                  value: response.data.ran,
                })
              );

              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
                  value: storeConfigState?.themeConfig
                    ?.return_submission_store_credit_left_content
                    ? storeConfigState?.themeConfig
                        ?.return_submission_store_credit_left_content
                    : `${storeConfigState?.themeConfig?.your_return_request} ${isShowRAN} ${storeConfigState?.themeConfig?.request_submitted_store_credit}`,
                })
              );

              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_THANKYOU_CARD_HEADING,
                  value:
                    storeConfigState?.themeConfig
                      ?.return_submission_store_credit_right_card_title,
                })
              );

              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_KEEP_THE_ITEM_AMOUNT_DESCRIPTION,
                  value:
                    storeConfigState?.themeConfig
                      ?.return_submission_store_credit_right_card_subtitle,
                })
              );
            }

            // Update product list
            const updatedOrderInfo = getUpdatedOrderInfo(
              productDetailsState,
              selectedProductDetailsState
            );

            // Update the product list on Redux
            dispatch(
              setProductDetails({
                key: productActionTypes.SET_ORDER_INFO,
                value: updatedOrderInfo,
              })
            );
            setIsBtnDisabled(false);
          }
        }
        } catch (error) {
          console.log(error);
        }
      } else if (refundReturnID === "3") {
        navigate("/RefundOptions");
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NAVIGATE_BACK,
            value: "/refund",
          })
        );
      }
    })();
  };

  return (
    <main className="reason">
      <div className="saara__container">
        <div className=" saara-justify-content-center row__title">
          <Link to="" onClick={backHandler} className="btn__small_screen">
            <img src="assets/svg/chevron_left.svg" width="24" alt="back" />
          </Link>
          <h1 className="return-review-title">{REVIEW_RETURN}</h1>
        </div>
        <div className="saara-return-review-card-main">
          <ReviewExchangeSummary isReturn={true} />
          <ContactInfoCard toggleModal={toggleModal} />
        </div>
        <div className="btns">
          <div className="btn__big_screen margin-right-20">
            <button
              className="saara_custom_btn btn__back"
              onClick={backHandler}
            >
              {storeConfigState?.themeConfig?.back_button_label}
            </button>
            {refundSettingsState.paymentRequired && refundSettingsState?.collectPaymentThrough === 'razorpay' ? (
              <RazorPay
                api_key={
                  refundSettingsState.paymentGatewayInfo.additional_data.api_key
                }
                amount={
                  refundSettingsState.paymentGatewayInfo.additional_data.amount
                }
                payment_description={
                  refundSettingsState.paymentGatewayInfo.additional_data
                    .payment_description
                }
                image={
                  refundSettingsState.paymentGatewayInfo.additional_data
                    .store_name
                }
                collectPaymentThrough={
                  refundSettingsState?.collectPaymentThrough 
                }
                notes={
                  refundSettingsState?.paymentGatewayInfo?.additional_data?.notes
                }
                razorpay_order_id={
                  refundSettingsState?.paymentGatewayInfo?.razorpay_order_id
                }
                store_name={storeConfigState.storeName}
                route_name="return"
              />
            )  : refundSettingsState.paymentRequired && refundSettingsState?.collectPaymentThrough === 'cashfree' ? (
              <CashFree
                  cashfree_reference_id={
                    refundSettingsState?.razorPayObject?.cashfree_reference_id
                  }
                  cashfree_session_id={
                    refundSettingsState?.razorPayObject?.cashfree_session_id
                  }
                  collectPaymentThrough={
                    refundSettingsState?.collectPaymentThrough 
                  }
                  store_name={storeConfigState?.storeName}
                  route_name="return"
              />
            ) : (
              <button
                className="saara_custom_btn btn__submit"
                onClick={buttonHandler}
                style={{ textTransform: "UPPERCASE", marginLeft: "10px" }}
                disabled={isBtnDisabled}
              >
                {isLoader ? (
                  <div
                    className="saara-spinner-border saara-spinner-border-sm"
                    role="status"
                  >
                    <span className="saara-visually-hidden"></span>
                  </div>
                ) : (
                  storeConfigState?.themeConfig?.submit_return
                )}
              </button>
            )}
          </div>
        </div>
      </div>
      {/*Modal */}
      {isModalOpen && (
        <div className="saara-modal-backdrop">
          <ContactInfoModal onRequestClose={toggleModal} />
        </div>
      )}
    </main>
  );
};
